import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerFooter,
  DrawerClose,
} from "@/components/ui/drawer";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { SortableNavItem } from "./SortableNavItem";
import type { NavItem } from "./navItems";

interface BottomNavCustomizerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  primaryItems: NavItem[];
  moreItems: NavItem[];
  primaryPaths: string[];
  onToggle: (path: string) => void;
  onDragEnd: (event: any) => void;
}

export function BottomNavCustomizer({
  open,
  onOpenChange,
  primaryItems,
  moreItems,
  primaryPaths,
  onToggle,
  onDragEnd,
}: BottomNavCustomizerProps) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Anpassa meny</DrawerTitle>
        </DrawerHeader>
        <ScrollArea className="px-4 max-h-[50vh]">
          <div className="space-y-4 pb-4">
            <div>
              <p className="text-xs text-muted-foreground mb-3 font-semibold">
                Huvudmeny (dra för att sortera)
              </p>
              <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
                <SortableContext items={primaryPaths} strategy={verticalListSortingStrategy}>
                  <div className="space-y-1.5">
                    {primaryItems.map((item) => (
                      <SortableNavItem key={item.path} item={item} isEditing isPrimary onToggle={onToggle} />
                    ))}
                  </div>
                </SortableContext>
              </DndContext>
            </div>
            {moreItems.length > 0 && (
              <div className="space-y-1.5 pt-4 border-t">
                <p className="text-xs text-muted-foreground font-semibold">Andra alternativ</p>
                {moreItems.map((item) => (
                  <SortableNavItem key={item.path} item={item} isEditing isPrimary={false} onToggle={onToggle} />
                ))}
              </div>
            )}
          </div>
        </ScrollArea>
        <DrawerFooter>
          <DrawerClose asChild>
            <Button>Klar</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
